import React from 'react';

import Card from 'components/Card/Card';
import { makeStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import ButtonDelete from 'hooks/ButtonDelete';
import { AccountBalanceWallet, ArrowDropDown, ArrowDropUp } from '@material-ui/icons';

export default WithApp(function TableCrudCustom(props) {
  const useStyles = makeStyles({
    table: {
      minWidth: props.minWidth
    }
  });

  const classes = useStyles();

  const {
    columns,
    listDetails,
    saveItemRow,
    setOpen,
    type,
    setIsUpdate,
    children,
    closeEditCell = undefined
  } = props;

  /**
   *
   * @param {valor} numero
   * @returns true or false
   */
  function isDecimal(numero) {
    let dataReturn = false;
    if (isNaN(numero)) {
      dataReturn = false;
    } else {
      if (numero % 1 == 0) {
        dataReturn = false;
      } else {
        dataReturn = true;
      }
    }
    return dataReturn;
  }

  return (
    <Card>
      <TableContainer>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              {columns.map((item, i) => {
                return (
                  <TableCell key={i} width={item.width} align={item.align}>
                    {item.title}
                  </TableCell>
                );
              })}
              {closeEditCell !== undefined && closeEditCell ? undefined : (
                <TableCell>Acciones</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {children}

            {[...listDetails].map((listDetail, i) => {
              const listDetailPrice = parseFloat(listDetail.price).toFixed(4);
              const listDetailLastPrice = parseFloat(listDetail.last_purchase_price_um).toFixed(4);

              let colorRow = 'white';
              if (listDetail.DiscPrcnt < 100) {
                colorRow =
                  listDetailPrice > listDetailLastPrice
                    ? '#ff00001f' // rojo
                    : listDetailPrice < listDetailLastPrice
                    ? '#00d11a45' // verde
                    : 'white';
              }

              return (
                <TableRow key={i} style={{ backgroundColor: colorRow }}>
                  <TableCell align="right">
                    <span
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      {i + 1}
                      {type === 'P' ? (
                        closeEditCell ? undefined : (
                          <Tooltip title="Concepto" placement="right">
                            <IconButton
                              aria-label="delete"
                              color="secondary"
                              onClick={() => {
                                setIsUpdate({ open: true, id: listDetail.id });
                                setOpen(true);
                              }}
                            >
                              <AccountBalanceWallet />
                            </IconButton>
                          </Tooltip>
                        )
                      ) : undefined}

                      {type === 'M' ? (
                        listDetail.DiscPrcnt >= 100 ? undefined : listDetailPrice >
                          listDetailLastPrice ? (
                          <Tooltip
                            title={(
                              parseFloat(listDetailPrice) - parseFloat(listDetailLastPrice)
                            ).toFixed(2)}
                          >
                            <ArrowDropUp
                              style={{
                                fontSize: '35px',
                                color: 'red',
                                cursor: 'pointer'
                              }}
                            />
                          </Tooltip>
                        ) : listDetailPrice < listDetailLastPrice ? (
                          <Tooltip
                            title={(
                              parseFloat(listDetailLastPrice) - parseFloat(listDetailPrice)
                            ).toFixed(2)}
                          >
                            <ArrowDropDown
                              style={{
                                fontSize: '35px',
                                color: 'green',
                                cursor: 'pointer'
                              }}
                            />
                          </Tooltip>
                        ) : undefined
                      ) : undefined}
                    </span>
                  </TableCell>
                  {columns.map((item, i) => {
                    let show;
                    let field = listDetail[item.field];

                    if (isDecimal(field)) {
                      if (item.field === 'LineTotal' || item.field === 'gtotal') {
                        field = parseFloat(field).toFixed(2);
                      } else {
                        field = parseFloat(field).toFixed(4);
                      }
                    }

                    if (item.field == 'pymt_concept_description') {
                      field = (
                        <Tooltip
                          title={`${listDetail.base_zone_description || ''} - ${
                            listDetail.pymt_expense_center_description || ''
                          }`}
                          placement="left"
                        >
                          <span
                            style={{
                              color: 'white',
                              background: '#00a1ff',
                              borderRadius: '5px',
                              padding: '2px 2px',
                              cursor: 'pointer'
                            }}
                          >
                            {field || 'Vacío'}
                          </span>
                        </Tooltip>
                      );
                    }

                    if (item.edit) {
                      if (closeEditCell !== undefined && closeEditCell) {
                        show = field;
                      } else {
                        show = (
                          <TextField
                            key={field}
                            name={item.field}
                            defaultValue={field}
                            inputProps={{ min: 0 }}
                            size="small"
                            fullWidth
                            type={item.type}
                            onBlur={(e) => {
                              saveItemRow(listDetail.id, { [e.target.name]: e.target.value });
                            }}
                          />
                        );
                      }
                    } else {
                      show = field;
                    }

                    return (
                      <TableCell key={i} align={item.align}>
                        {show}
                      </TableCell>
                    );
                  })}
                  {closeEditCell !== undefined && closeEditCell ? undefined : (
                    <TableCell>
                      <ButtonDelete
                        entity={props.deleteDetailEntity}
                        id={listDetail.id}
                        reload={props.reloadDetail}
                        style={{ height: 0 }}
                      />
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
});
